namespace RS.ExternalHelp
{
    export class ServerVersionPlugin extends RS.ExternalHelp.VisitorPlugin
    {
        private _serverVersion: string;

        public constructor(page: RS.ExternalHelp.IPage)
        {
            super(page);
            this._serverVersion = RS.URL.getParameter("serverVersion");
        }

        public onElementLoaded(element: HTMLElement)
        {
            const eID = element.id;
            if (eID == "rs-server")
            {
                element.innerHTML = element.innerHTML.replace("{serverVersion}", this._serverVersion);
            }
        }
    }
    RS.ExternalHelp.pluginRegistry.register(ServerVersionPlugin);
}